import { Base, ListChunk } from '@idea2app/ai-work-order-service';
import { Filter, IDType, ListModel, toggle } from 'mobx-restful';
import { buildURLData } from 'web-utility';

import userStore from './User';

export abstract class TableModel<
    D extends Base,
    F extends Filter<D> = Filter<D>
> extends ListModel<D, F> {
    client = userStore.client;

    @toggle('uploading')
    async updateOne(data: Filter<D>, id?: IDType) {
        const { body } = await (id
            ? this.client.put<D>(`${this.baseURI}/${id}`, data)
            : this.client.post<D>(this.baseURI, data));

        return (this.currentOne = body!);
    }

    async loadPage(pageIndex: number, pageSize: number, filter: F) {
        const { body } = await this.client.get<ListChunk<D>>(
            `${this.baseURI}?${buildURLData({ ...filter, pageIndex, pageSize })}`
        );
        return { pageData: body!.list, totalCount: body!.count };
    }
}
